import React from "react";
import { motion } from "framer-motion";
import "./ReleaseLoadingScreen.css";

const ReleaseLoadingScreen = ({ message = "Loading release data..." }) => {
    return (
        <div className="release-loading-screen" role="status" aria-live="polite">
            <div className="release-loading-screen__loader" aria-hidden="true">
                <div className="release-loading-screen__dots">
                    <motion.div
                        className="release-loading-screen__dot"
                        animate={{ scale: [1, 1.5, 1], opacity: [0.5, 1, 0.5] }}
                        transition={{ duration: 1, ease: "easeInOut", repeat: Infinity }}
                    />
                    <motion.div
                        className="release-loading-screen__dot"
                        animate={{ scale: [1, 1.5, 1], opacity: [0.5, 1, 0.5] }}
                        transition={{ duration: 1, ease: "easeInOut", repeat: Infinity, delay: 0.3 }}
                    />
                    <motion.div
                        className="release-loading-screen__dot"
                        animate={{ scale: [1, 1.5, 1], opacity: [0.5, 1, 0.5] }}
                        transition={{ duration: 1, ease: "easeInOut", repeat: Infinity, delay: 0.6 }}
                    />
                </div>
            </div>
            <h4 className="release-loading-screen__title">{message}</h4>
            <p className="release-loading-screen__subtitle">Please wait</p>
        </div>
    );
};

export default ReleaseLoadingScreen;
